export const teamsMenuI18NDe = {
    allTeams: "Alle Teams",
    myTeams: "Meine Teams",
    addTeam: "Neues Team erstellen",
    removeTeam: (name: string) => `${name} löschen`,
    removeTeamNotice: (name: string) => `Das Team '${name}' wird gelöscht.`,
};
